function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "House Alt Icon");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "house-Icon/Global/Business_Lines/Personal",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "house-Group",
  transform: "translate(1.000000, 2.000000)",
  stroke: "currentcolor"
}, /*#__PURE__*/React.createElement("polyline", {
  id: "house-Path-2",
  strokeLinecap: "round",
  points: "4.63758874 15.9545455 4.63758874 49.0454545 47.1830433 49.0454545 47.1830433 15.9545455"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "house-Path-3",
  points: "30.7653486 48.8468433 30.7653486 33.0909091 21.2727273 33.0909091 21.2727273 48.8468433"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "house-Path-6",
  strokeLinecap: "round",
  points: "51.6757133 19.1984606 26.0564887 0 1.34357172e-13 19.1984606"
})));

var SvgHouseAlt = function SvgHouseAlt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 54 54",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHouseAlt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/house-alt.d5606f63.svg";
export { ForwardRef as ReactComponent };